import { money } from "../../lib/finance";

/** Amount without the currency suffix. Insights states the currency once per section. */
export const figure = (value: number | null, currency: string) =>
  value === null ? "—" : money(value, currency).replace(` ${currency}`, "");

/** Signed change for ticker columns: "+1,234.00", "−56.00". */
export const signedFigure = (value: number | null, currency: string) =>
  value === null ? "—" : `${value > 0 ? "+" : value < 0 ? "−" : ""}${figure(Math.abs(value), currency)}`;

/** Spending moving up is the warning direction, so "up" renders orange and "down" mint. */
export const tickerClass = (value: number | null) =>
  value === null || value === 0 ? "flat" : value > 0 ? "up" : "down";
